var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('div',{staticClass:"ldr-text"},[_c('div',[_c('img',{staticClass:"img-fluid",attrs:{"src":"/images/svg/loader.svg","alt":""}}),_c('h1',[_vm._v("\n          "+_vm._s(_vm._T('Sorry we could not access our web server'))+"..\n          "+_vm._s(_vm._T(`Please relaod
          page in 5 mins`))+"\n        ")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }